import script from "./CreateAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateAccount.vue?vue&type=script&setup=true&lang=js"

import "./CreateAccount.vue?vue&type=style&index=0&id=bb5cd6e8&lang=scss"

const __exports__ = script;

export default __exports__